const defaultRoleKeys = [
  "superadmin",
  "admin",
  "moderator",
  "demo",
  "active",
  "blocked",
];

export default defaultRoleKeys;
